import React from "react"
import styled from "@emotion/styled"
import { mq } from "../mixins"
import { convertContentStackAsset } from "../../utils"
import "./navigationMenuBlock.scss"
import LinkDropdownWrapper from './linkDropdownWrapper';

const NavigationMenuBlock = props => {
  const StyledNavigationMenuBlockWrapper = styled("div")`
    width: 100%;
    text-align: center;
    margin: 0 auto;
    padding:3rem 0 3rem;

      .container {
        padding:  1rem;

          .nav_menu_block_header {
            margin: 1rem 0rem;
          }

          .link_list_container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin: 0px auto;
            ${mq("tablet")} {
              flex-direction: row;
              justify-content: space-evenly;
              align-items:flex-end;
              flex-wrap: wrap;
              max-width: 920px;
            }
            ${mq("desktop")} {
              max-width: 1024px;
            }
            .menu_link {
              display:flex;
              align-items:center;
              font-family: 'Open Sans', Georgia, sans-serif;
              font-style: normal;
              font-weight: bold;
              font-size: 1rem;
              line-height: 1.5;
              color: ${(props) => props.textColor};
              cursor: pointer;
              text-align:left;
              font-weight:700;
              min-height:46px;
            }
            .primary_link_container {
              position: relative;
              .primary_link_container__image{
                width:115px;
                padding-top:2.5rem;
              }
              .link-wrapper {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0.5rem;
                border-bottom: 2px solid ${(props) => props.subItemDropdownColor};

                &.current_page {
                  border-bottom: 2px solid ${(props) => props.themeColor};
                }

                ${mq("tablet")} {
                  justify-content: left;
                  margin: 1rem 2rem;
                  width: 15rem;
                }
                .arrow_icon {
                  margin-left: 0.75rem;
                  width: 0;
                  height: 0;
                  border-left: 6px solid transparent;
                  border-right: 6px solid transparent;
                  border-bottom: 8px solid ${(props) => props.arrowColor};
                  border-top: none;
                  transition: transform 0.3s ease-in-out;
                  cursor: pointer;

                  &.pointing_down {
                    transform: rotateX(180deg);
                  }
                }
              }

              &.primary_link_container--dropdown,
              &.primary_link_container--link {
                .link-wrapper {
                  position: relative;
                  cursor: pointer;
                  &::after {
                    content: '';
                    position: absolute;
                    width: 0%;
                    height: 2px;
                    bottom: -1px;
                    background-color: ${(props) => props.themeColor};
                    transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
                    left: 0%;
                    ${mq("tablet")} {
                    left: 50%;
                    transform: translateX(-50%);
                  }
                }
                &:hover {
                  &::after {
                    width: 100%;
                  }
                }
                &:focus {
                  &::after {
                    width: 100%;
                  }
                }
                }
              }

              .sub_link_container {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                padding: 1.5rem 2rem 0.5rem 2rem;
                background: ${(props) => props.subItemDropdownColor};
                margin-top: .5rem;
                ${mq("tablet")} {
                  position: absolute;
                  top: 240px;
                  left: 32px;
                  width: 15rem;
                  text-align: left;
                  z-index: 5;     
                  margin-top: 1rem;

                }
                &.collapsed {
                  display: none;
                }
                .menu_link {
                  margin-bottom: 1rem;
                }
              }
            }
          }
      }
    `;

  return (
    <StyledNavigationMenuBlockWrapper
      className={`navigation_menu_block ${
      props.color_theme === "light" ? "light" : "dark"
      }`}
      themeColor={props.theme_color}
      subItemDropdownColor={props.sub_item_dropdown_menu_color}
      arrowColor={props.color_theme === "light" ? "black" : "white"}
    >
      <div className="container">
        <h2 className="nav_menu_block_header">{props.headline}</h2>
        <div className="link_list_container">
          {props.menu_items.map((menu_item, i) => {
            if (!menu_item.item.sub_items || menu_item.item.sub_items.length > 0) {
              return (
                <LinkDropdownWrapper
                  key={`navigation-menu-block-${props.uid}-${i}`}
                  data={menu_item.item}
                ></LinkDropdownWrapper>
              );
            } else {
              return (
                <div className="primary_link_container primary_link_container--link">
                  {!menu_item.item.image.url.length > 0 ? null : 
                    <img
                      src={convertContentStackAsset(menu_item.item.image.url)}
                      className="primary_link_container__image"
                    ></img>
                    }
                    <div className="link-wrapper">
                      <a
                        className="menu_link"
                        href={menu_item.item.item_url.href}
                      >
                        {menu_item.item.item_url.title}
                      </a>
                    </div>
                  </div>
                );
              }
          })}
        </div>
      </div>
    </StyledNavigationMenuBlockWrapper>    
  )

}
export default NavigationMenuBlock;